import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Après redirection depuis public/404.html (Static Site Render). */
export default function SpaPathRecovery() {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const saved = sessionStorage.getItem('spa_path');
      if (saved && saved !== '/' && saved !== '/index.html') {
        sessionStorage.removeItem('spa_path');
        navigate(saved, { replace: true });
      }
    } catch (_) {
      /* ignore */
    }
  }, [navigate]);

  return null;
}
